import CostReviewForUnregisterdUser from "./component/CostReviewForUnregisterdUser";

const rfq = {
  path: "costReview",

  // topNav: {
  //   order: 30,
  //   label: "RFQ",
  //   entityType: ["ebp"],
  //   allowedRole: "all",
  //   auth: ["unAuthenticated"],
  // },
  route: {
    index: {
      element: <CostReviewForUnregisterdUser />,
      allowedRole: ["public"],
      entityType: ["ebp"],
      auth: ["unAuthenticated"],
    },
  },
};

export default rfq;
